export default "__VITE_ASSET__xeTlBLhJ__"